exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statementbtn[data-v-3fc30b32]{margin-bottom:18px;display:-ms-grid;display:grid;grid-gap:12px}@media screen and (min-width:500px){.statementbtn[data-v-3fc30b32]{-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr);grid-gap:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fc30b32","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/statementbtn/StatementBtn.vue
// module id = 015ef4c80d55a8c139cf
// module chunks = 9